module.exports = __webpack_public_path__ + "public/files/img/classroom3.30e46fa0.png";